import React from 'react';
import Wrapper from '../enb-styled/Wrapper';

const Title = ({ content }) => <Wrapper as={'h1'}>{content}</Wrapper>;

export default Title;
